<template>
    <div class="request-manager"  :class="{hide : Object.values(requests).length == 0, open : isOpen}" ref="requestManager" @click="open">
        <header ref="header">
            <h4>{{ textHeader }}</h4>
            <div class="square">
                <i class="fa-regular fa-paper-plane"></i>
                <div class="progress-circle" ref="progressCircle">
                   
                </div>
            </div>
        </header>
        <div class="container-list-request hide-scrollbar">
            <div class="list-request" ref="listRequest">
                <div class="item"  v-for="request in Object.values(requests)" :key="request.id">
                    <div class="picture">
                        <img :src="request.picture ? request.picture : 'img/avatar.jpg'">
                    </div>

                    <div class="column">
                        <p class="title" v-html="request.title ? request.title : ''"></p>
                        <p class="success" v-if="request.status == 'success'" v-html="`<i class='fa-regular fa-circle-check'></i>${request.successText || 'Envoyé !'}`"></p>
                        <p class="error" v-if="request.status == 'error'" v-html="`<i class='fa-regular fa-circle-exclamation'></i>${request.errorText || 'Echec !'}`"></p>
                        <div class="container-progress" v-if="request.status == 'loading'">
                            <div class="bar"><div class="progress infinite"></div></div>
                            <p>{{request.loadingText ? request.loadingText : ""}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    
    export default {
        data() {
            return {

                isOpen : false,
                lastOpenTime: null,
                requests: {
                    // "23cv9ksk5" : {
                    //     "id":"23cv9ksk5",
                    //     "status":"error",
                    //     "picture":"https://s3-eu-west-1.amazonaws.com/saas.mashup/uploads/09khzr8jrmig-0aamaitresse-rise-scaled.jpg",
                    //     "title":"<span class=\"pink\">Enqueteexclusive2025</span>: post medias",
                    //     "loadingText":"En cours de publication...",
                    //     "successText": "Post publié avec succés",
                    //     "errorText": "Echec de lors de la publication",
                    // }
                },

                requestGroup: {

                }
            }
        },

        methods: {
            open() {
                this.isOpen = true
                this.lastOpenTime = Date.now();
                this.$refs.requestManager.style.height = `${this.$refs.listRequest.clientHeight + this.$refs.header.clientHeight }px`
                window.addEventListener('click', this.handleClickOutside);
            },
            close() {
                this.isOpen = false
                this.$refs.requestManager.style.height = ``
                window.removeEventListener("click", this.handleClickOutside, false);
                const timestamp = Date.now() 
                if (timestamp - this.lastOpenTime > 1000) {
                    Object.values(this.requests).forEach(request => {
                        if (request.status !== 'loading' && timestamp - request.updateAtStatus > 1000) {
                            this.$delete(this.requests, request.id);
                        }
                    });
                }
                this.updateProgressCircle()
            },
            successRequest(idRequest,text) {
                this.$set(this.requests[idRequest],'updateAtStatus', Date.now())
                this.$set(this.requests[idRequest],'status','success')
                if (text) this.$set(this.requests[idRequest], 'successText', text)
                this.updateProgressCircle()
            },
            changeProgressRequest(idRequest) {
                console.log(idRequest, "changeProgressRequest")
            },
            errorRequest(idRequest,text) {
                this.$set(this.requests[idRequest],'updateAtStatus', Date.now())
                this.$set(this.requests[idRequest],'status','error')

                if (text) this.$set(this.requests[idRequest], 'errorText', text)
                this.updateProgressCircle()
            },
            
            async addRequest(cbStartRequest,params) {
                const id = Math.random().toString(36).substr(2, 9)

                this.$set(this.requests, id, {
                        id,
                        status: 'loading',
                        ...params
                    }
                )
                this.updateProgressCircle()
                try {
                    await cbStartRequest(
                        (text)=>this.successRequest(id, text),
                        ()=>this.changeProgressRequest(id),
                        (text)=>this.errorRequest(id, text),
                        this.open
                    )
                }catch (error) {
                    this.errorRequest(id); // Gérer l'erreur de manière centralisée
                }
            },

            async requestManagerAddGroup(requests, cbFinish) {

                const idRequests = Array.from({length: requests.length}, () => Math.random().toString(36).substr(2, 9));
                const groupId = Math.random().toString(36).substr(2, 9);
                this.$set(this.requestGroup, groupId, idRequests)

                const promises = requests.map((request, i) => {
                    const id = idRequests[i];

                    this.$set(this.requests, id, {
                        id,
                        status: 'loading',
                        ...request.params,
                        groupId
                    });

                    return request.start(
                        (text) => {
                            this.successRequest(id, text)
                        },
                        () => this.changeProgressRequest(id),
                        (text) => {
                            this.errorRequest(id, text)
                        },
                        this.open
                    ).catch(error => {
                        this.errorRequest(id); // Gérer l'erreur de manière centralisée
                    });
                });

               
                const responses = await Promise.all(promises);
                console.log('test1234',responses)
                this.updateProgressCircle();
                if (cbFinish) {
                    cbFinish(responses);
                }
                
                this.updateProgressCircle()
            },

            updateProgressCircle() {
                console.log('this.$refs.progressCircle test', this.$refs, this.$refs.progressCircle,this.$refs.header )

                if (this.$refs.progressCircle) this.$refs.progressCircle.style.setProperty('--progress-value', parseInt(Object.values(this.requests).filter(r => r.status !== "loading").length / Object.values(this.requests).length * 100));
            },

            handleClickOutside(event) {
               
                const targetElement = this.$refs.requestManager;
        
                if (!targetElement.contains(event.target)) {
                    window.removeEventListener("click", this.handleClickOutside, false);
                    this.close()
                }
            },
        },


        computed: {
            textHeader() {
                const requestsFilter = Object.values(this.requests).filter(r => r.status == "loading")
                return requestsFilter.length ?  `${requestsFilter.length} envoi${requestsFilter.length > 1 ? 's' : ''} en cours` : 'Historique des évènements'
            }
        },

        mounted() {
            EventBus.$on('requestManagerAdd', this.addRequest);
            EventBus.$on('requestManagerAddGroup', this.requestManagerAddGroup)
        },

        beforeDestroy () {
            EventBus.$off('requestManagerAdd', this.addRequest);
            EventBus.$off('requestManagerAddGroup', this.requestManagerAddGroup)
            window.removeEventListener("click", this.handleClickOutside);
        }
        
    }
</script>

<style lang="scss" scoped>

</style>